import * as React from 'react';
import { connect } from 'react-redux';
import './CaptureCarDetails.css';
import { navigateTo } from '../../../actions/navigationActions';
import NeedHelp from '../../BaseTemplate/SSPCustomComponentLibrary/NeedHelp/NeedHelp';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { CAPTURE_IMAGES, DASHBOARD, PERSONAL_INSURANCE } from '../../../routes/routes';
import { Form } from 'react-bootstrap';
import { saveCarDetails } from '../../../actions/selfInspectActions';
import ModernDatepicker from 'react-modern-datepicker';
import { showCallMeModal } from '../../../actions/modalActions';

class CaptureCarDetails extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            vinNr: "",
            regNr: "",
            licenceNr: "",
            licenceExpDate: "",
            engineNr: "",
            make: "",
            model: "",
            submitted: false,
            vinCheck: false,
            regCheck: false,
            licenceCheck: false,
            engineCheck: false,
            makeCheck: false,
            modelCheck: false,
            licenceDateCheck: false,
            canSubmitDisabled: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.submit = this.submit.bind(this);
        this.canSubmitCheck = this.canSubmitCheck.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
    } 

    handleCallMeBack = async (e: any) => {
        this.props.handleCallMeBack();
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
        if (this.state.submitted) {
            await this.canSubmitCheck();
        }
    }

    async handleChangeDate(date) {
        await this.setState({
            licenceExpDate: date
        });
        if (this.state.submitted) {
            await this.canSubmitCheck();
        }
    }

    handleBack() {
        this.props.redirectTo(CAPTURE_IMAGES);
    }

    async submit(e: any) {
        await this.setState({ submitted: true, vinCheck: this.state.vinNr !== "", regCheck: this.state.regNr !== "", licenceCheck: this.state.licenceNr !== "", engineCheck: this.state.engineNr !== "", makeCheck: this.state.make !== "", modelCheck: this.state.model !== "" })
        if (this.state.vinCheck && this.state.regCheck && this.state.licenceCheck && this.state.engineCheck && this.state.makeCheck && this.state.modelCheck) {
            this.props.dispatchSaveCarDetails(this.state.vinNr, this.state.regNr, this.state.licenceNr, this.state.licenceExpDate, this.state.engineNr, this.state.make, this.state.model)
        }
        else {
            await this.canSubmitCheck();
        }
    }

    async canSubmitCheck() {
        await this.setState({ vinCheck: this.state.vinNr !== "", regCheck: this.state.regNr !== "", licenceCheck: this.state.licenceNr !== "", engineCheck: this.state.engineNr !== "", makeCheck: this.state.make !== "", modelCheck: this.state.model !== "", licenceDateCheck: this.state.licenceExpDate !== ""})
        if (this.state.vinCheck && this.state.regCheck && this.state.licenceCheck && this.state.engineCheck && this.state.makeCheck && this.state.modelCheck && this.state.licenceDateCheck) {
            this.setState({ canSubmitDisabled: false })
        }
        else {
            this.setState({ canSubmitDisabled: true })
        }
    }

    public render() {

        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Car" }]
        if (this.props.selfInspect.selectedPersonalCover.product === 7) {
            BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Motorbike" }]
        }
        let submitted = this.state.submitted
        return (
            <>
                {this.props.selfInspect.selectedPersonalCover && this.props.selfInspect.selectedPersonalCover.riskItems[0] &&
                    <div id="CarDetails" className="container-fluid new-page-margins" >
                        <div className="new-breadcrumbwrapper breadcrumb-wrapper-capture-details-actual">
                            <KPBreadCrumb navList={BreadcrumbDetails} activePage="Self-inspection" />
                        </div>
                        <div className="row new-page-main-row">
                            <div className="StepBox capture-details-container">
                                <div className="capture-details-header">
                                    {this.props.selfInspect.selectedPersonalCover.product === 7 &&
                                        <h3 className="carName">Motorbike inspection</h3>
                                    }
                                    {this.props.selfInspect.selectedPersonalCover.product !== 7 &&
                                        <h3 className="carName">Car inspection</h3>
                                    }
                                    <p className="Step-Description">{this.props.selfInspect.selectedPersonalCover.riskItems[0].description}</p>
                                </div>
                                <div className="row capture-details-header-bottom-border"></div>


                                {/*///  SSP Vertical Progress Bar Container ///*/}
                                {/*/// Change row class ssp-vpb-step-done-or-current to ssp-vpb-step-done / ssp-vpb-step-current ///*/}
                                <div className="ssp-vertical-progressbar-container">
                                    {/*/// Step ///*/}
                                    <div className="row ssp-vpb-row ssp-vpb-step-done">
                                        <div className="ssp-vpb-mark">
                                            <div className="ssp-vpb-mark-line">
                                                <div className="ssp-vpb-mark-icon"></div>
                                            </div>
                                        </div>
                                        <div className="col ssp-vpb-content">
                                            <span>Snap a photo</span>
                                        </div>
                                    </div>
                                    {/*/// Step End ///*/}
                                    {/*/// Step ///*/}
                                    <div className="row ssp-vpb-row ssp-vpb-step-current">
                                        <div className="ssp-vpb-mark">
                                            <div className="ssp-vpb-mark-line">
                                                <div className="ssp-vpb-mark-icon"></div>
                                            </div>
                                        </div>
                                        <div className="col ssp-vpb-content">
                                            {/* /// STEP CONTENT /// */}
                                            <div className="capture-details-step-holder">

                                                <div className="capture-details-step-header">
                                                    {this.props.selfInspect.selectedPersonalCover.product === 7 &&
                                                        <>
                                                            <h3>Motorbike details</h3>
                                                            <p>You're almost done! Fill in your licence disc's details below (psst, your licence disc is the round sticker somewhere towards the back of your bike)</p>
                                                        </>
                                                    }
                                                    {this.props.selfInspect.selectedPersonalCover.product !== 7 &&
                                                        <>
                                                            <h3>Car details</h3>
                                                            <p>You're almost done! Fill in your licence disc's details below (psst, your licence disc is the round sticker on your front windscreen)</p>
                                                        </>
                                                    }
                                                </div>

                                                {/*/// Note: ///
                                                For now, please continue to pass the 'form-has-error' class to this holding Div if the fields have errors
                                                - as this handles an error notice display
                                                */}
                                                <div className={(submitted && !this.state.vinNr || submitted && !this.state.regNr || submitted && !this.state.licenceNr || submitted && !this.state.licenceExpDate || submitted && !this.state.engineNr || submitted && !this.state.make || submitted && !this.state.model ? ' form-has-error' : '')}>
                                                {/* /// Form actual ///*/}

                                                    <div className={'form-group' + (submitted && !this.state.vinNr ? ' has-error' : '')}>
                                                        <Form.Label className={'new-form-label' + (this.state.vinNr !== "" ? "" : " no-opacity")}>VIN no.</Form.Label>
                                                        <Form.Control className={(submitted && !this.state.vinNr ? 'redunderline' : "underline")} type="text" placeholder="VIN no." id="vinNrInput" name="vinNr" value={this.state.vinNr} onChange={this.handleChange} />
                                                        {submitted && !this.state.vinNr &&
                                                            <div className="help-block">VIN no. is required</div>
                                                        }
                                                    </div>
                                                    <div className={'form-group' + (submitted && !this.state.regNr ? ' has-error' : '')}>
                                                        <Form.Label className={'new-form-label' + (this.state.regNr !== "" ? "" : " no-opacity")}>Reg no.</Form.Label>
                                                        <Form.Control className={(submitted && !this.state.regNr ? 'redunderline' : "underline")} type="text" placeholder="Reg no." id="regNrInput" name="regNr" value={this.state.regNr} onChange={this.handleChange} />
                                                        {submitted && !this.state.regNr &&
                                                            <div className="help-block">Registration no. is required</div>
                                                        }
                                                    </div>
                                                    <div className={'form-group' + (submitted && !this.state.licenceNr ? ' has-error' : '')}>
                                                        <Form.Label className={'new-form-label' + (this.state.licenceNr !== "" ? "" : " no-opacity")}>Licence no.</Form.Label>
                                                        <Form.Control className={(submitted && !this.state.licenceNr ? 'redunderline' : "underline")} type="text" placeholder="Licence no." id="licenceNrInput" name="licenceNr" value={this.state.licenceNr} onChange={this.handleChange} />
                                                        {submitted && !this.state.licenceNr &&
                                                            <div className="help-block">Licence no. is required</div>
                                                        }
                                                    </div>
                                                    <div className={'form-group calendar-holder' + (submitted && !this.state.licenceExpDate ? ' has-error' : '')}>
                                                        <Form.Label className={'new-form-label' + (this.state.licenceExpDate !== "" ? "" : " no-opacity")}>Licence expiry date</Form.Label>
                                                        <ModernDatepicker
                                                            date={this.state.licenceExpDate}
                                                            format={'DD-MM-YYYY'}
                                                            showBorder
                                                            onChange={(date) => this.handleChangeDate(date)}
                                                            placeholder='Licence expiry date'
                                                            className="calendar-inline-icon inspectCalendar mx-auto"
                                                        />
                                                        {submitted && !this.state.licenceExpDate &&
                                                            <div className="help-block">Licence expiry date is required</div>
                                                        }
                                                    </div>
                                                    <div className={'form-group' + (submitted && !this.state.engineNr ? ' has-error' : '')}>
                                                        <Form.Label className={'new-form-label' + (this.state.engineNr !== "" ? "" : " no-opacity")}>Engine no.</Form.Label>
                                                        <Form.Control className={(submitted && !this.state.engineNr ? 'redunderline' : "underline")} type="text" placeholder="Engine no." id="engineNrInput" name="engineNr" value={this.state.engineNr} onChange={this.handleChange} />
                                                        {submitted && !this.state.engineNr &&
                                                            <div className="help-block">Engine no. is required</div>
                                                        }
                                                    </div>
                                                    <div className={'form-group' + (submitted && !this.state.make ? ' has-error' : '')}>
                                                        <Form.Label className={'new-form-label' + (this.state.make !== "" ? "" : " no-opacity")}>Make</Form.Label>
                                                        <Form.Control className={(submitted && !this.state.make ? 'redunderline' : "underline")} type="text" placeholder="Make" id="makeInput" name="make" value={this.state.make} onChange={this.handleChange} />
                                                        {submitted && !this.state.make &&
                                                            <div className="help-block">Make is required</div>
                                                        }
                                                    </div>
                                                    <div className={'form-group last-of-class' + (submitted && !this.state.model ? ' has-error' : '')}>
                                                        <Form.Label className={'new-form-label' + (this.state.model !== "" ? "" : " no-opacity")}>Model</Form.Label>
                                                        <Form.Control className={(submitted && !this.state.model ? 'redunderline' : "underline")} type="text" placeholder="Model" id="modelInput" name="model" value={this.state.model} onChange={this.handleChange} />
                                                        {submitted && !this.state.model &&
                                                            <div className="help-block">Model is required</div>
                                                        }
                                                    </div>

                                                    <div className="row d-flex justify-content-center capture-details-button-holder">
                                                        <div className="col-12 showsubmit-error">
                                                            Please complete all the required fields
                                                        </div>
                                                        <div className="col-12 capture-details-button-holder-actual">
                                                            <div className="row justify-content-center">
                                                                <div className="col capture-details-buttons-col-back">
                                                                <button className="btn btn-block btn-outline-red" type="button" id="CancelCarData" onClick={this.handleBack}>Back</button>
                                                                </div>
                                                            <div className="col capture-details-buttons-col-next">
                                                                <button className="btn btn-block btn-solid-red  btn-red-disabled-handler" type="submit" id="NextCarData" disabled={this.state.canSubmitDisabled} onClick={this.submit}>Next</button>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    </div>
                                                </div>

                                                {/*/// end form actual ///*/}

                                            </div>
                                        </div>
                                    </div>
                                    {/*/// Step End ///*/}
                                    {/*/// Step ///*/}
                                    <div className="row ssp-vpb-row ssp-vpb-step-next">
                                        <div className="ssp-vpb-mark">
                                            <div className="ssp-vpb-mark-line">
                                                <div className="ssp-vpb-mark-icon"></div>
                                            </div>
                                        </div>
                                        <div className="col ssp-vpb-content">
                                            <span>T's & C's</span>
                                        </div>
                                    </div>
                                    {/*/// Step End ///*/}
                                    {/*/// Step: Current ///*/}
                                    <div className="row ssp-vpb-row ssp-vpb-step-next">
                                        <div className="ssp-vpb-mark">
                                            <div className="ssp-vpb-mark-line">
                                                <div className="ssp-vpb-mark-icon"></div>
                                            </div>
                                        </div>
                                        <div className="col ssp-vpb-content">
                                            <span>Done</span>
                                        </div>
                                    </div>
                                    {/*/// Step End ///*/}

                                    {/* /// End Vertical Progress Steps ///*/}
                                </div>
                                {/*/// End SSP Vertical Progress Bar Container ///*/}

                            </div>
                        </div>
                    <div className="row selfinspection-needhelp-row d-none">{/*{hidden for now untill we have a generic block}*/}
                            <div className="col">
                              <NeedHelp
                                isSelfInspect={true}
                                countryId={this.props.profile.countryId}
                                claimsEmail={this.props.ssp.claims_email}
                                contactUsTel={this.props.ssp.contactUs_tel}
                                handleCallMeBack={(e) => this.handleCallMeBack(e)}
                                />
                            </div>
                        </div>
                    </div>
                }
            </>

        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        selfInspect: state.selfInspect,
        ssp: state.ssp
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
        dispatchSaveCarDetails: (vinNr, regNr, licenceNr, licenceExpDate, engineNr, make, model) => dispatch(saveCarDetails(vinNr, regNr, licenceNr, licenceExpDate, engineNr, make, model)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaptureCarDetails);